import React from 'react';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';
import { Text, InternalGrid } from '@paygreen/paygreen-ui';
import { PopinInfo } from '../../../../components';
import { dispatchFromKg } from '../../../../utils/co2-calculator';
import IconByName from '../../../../utils/IconByName';
import { convertToKg } from '../../../../utils/tools';
import CarbonEquivalenceContent from './CarbonEquivalenceContent';

const CarbonEquivalencePopin = ({
    colorStatus,
    carbonValue,
    iconStyle,
    position,
    unit,
    hasPopin,
    hasDataLegend,
}) => {
    const { value, type } = dispatchFromKg(
        convertToKg(carbonValue, unit),
        true,
    );

    let iconName = null;
    let popinContent = null;

    switch (type) {
        case 'plane':
            iconName = 'PlaneIcon';
            break;
        case 'scooter':
            iconName = 'ScooterIcon';
            break;
        case 'car':
            iconName = 'CarIcon';
            break;
        default:
            iconName = 'WeightIcon';
            break;
    }

    return (
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto 1fr"
            justifyItems="start"
            gridGap="sm"
            hasStaticWidth={false}
        >
            <IconByName name={iconName} {...iconStyle} />

            <Text textSize={hasDataLegend ? 'sm' : 'xs'} htmlTag="div">
                <Trans
                    i18nKey={`dashboard.equivalence.transports.${type}.km`}
                    values={{ kmValue: value }}
                >
                    C'est l'équivalent d'un vol de
                    <Text
                        htmlTag="strong"
                        textSize={hasDataLegend ? 'sm' : 'xs'}
                        colorPallet="status"
                        colorStatus={colorStatus}
                    >
                        {{ value }}
                    </Text>
                </Trans>

                {hasPopin && (
                    <PopinInfo
                        colorStatus={colorStatus}
                        isActive={true}
                        popinWidth="lg"
                        popinPosition={position}
                        popinPadding="md"
                    >
                        <CarbonEquivalenceContent
                            carbonValue={carbonValue}
                            unit={unit}
                        />

                        {popinContent || null}
                    </PopinInfo>
                )}
            </Text>
        </InternalGrid>
    );
};

CarbonEquivalencePopin.propTypes = {
    /**
     * Display the color
     */
    colorStatus: PropTypes.string,
    /**
     * Value in KG
     */
    carbonValue: PropTypes.number.isRequired,
    /**
     * Unit of carbonValue
     */
    unit: PropTypes.string.isRequired,
    /**
     * Position of Popin
     */
    position: PropTypes.string,
    hasPopin: PropTypes.bool,
    hasDataLegend: PropTypes.bool,
};

CarbonEquivalencePopin.defaultProps = {
    hasPopin: true,
    hasDataLegend: true,
};

export default withTranslation('common')(CarbonEquivalencePopin);
